import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=2f2c4f16&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=2f2c4f16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c4f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2c4f16')) {
      api.createRecord('2f2c4f16', component.options)
    } else {
      api.reload('2f2c4f16', component.options)
    }
    module.hot.accept("./CustomerDetail.vue?vue&type=template&id=2f2c4f16&scoped=true", function () {
      api.rerender('2f2c4f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerDetail.vue"
export default component.exports